import axios from 'axios'
// import router from '../router'
// import store from './Store'

const api = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 600000,
    params: {} // do not remove this, its added to add params later in the config
});


export default api
